import React, { useState, useEffect } from "react";
import { useMetaMask } from "metamask-react";
import { Switch, Route, useHistory } from "react-router";

import { CodiaxProvider } from "./CodiaxContext";
import CodiaxMintPage from "./CodiaxMintPage/CodiaxMintPage";
import CodiaxLogin from "./CodiaxLogin/CodiaxLogin";
import CodiaxDataPage from "./CodiaxDataPage/CodiaxDataPage";
import CodiaxHelpPage from "./CodiaxHelpPage/CodiaxHelpPage";
import { isElectronApp } from "../../../helpers/Utils";
import { Weave } from "./Weave"

export default function CodiaxWrapperPage() {
	const history = useHistory();
	const [ user, setUser ] = useState(null);
	const [ weave ] = useState(new Weave());
	const [ hasAccess, setHasAccess ] = useState(false);
	const [ showConnect, setShowConnect ] = useState(true);
	const [ showMint, setShowMint ] = useState(false);
	const meta = useMetaMask();

	const path = "codiax";

	useEffect(() => {
		// Set user from metamask
		if (meta?.status === "connected") {
			setShowConnect(false);
			setUser({
				metamaskAccount: meta.account,
				avatar: "metamask",
			});

			login();
		} else {
			setShowConnect(true);
			setShowMint(false);
			setUser(null);
		}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [meta]);

	// ------------------------------------- METHODS -------------------------------------
	const logout = () => {
		setUser(null);
		history.push(`/${path}/`);
	};

	const login = async () => {
		try {
			const {session} = await weave.connect();
			const isAuthorized = session.scopes.includes("codiax");
			setHasAccess(isAuthorized)
			setShowMint(!isAuthorized)
			if (isAuthorized) {
				history.push(`/${path}/data`);
			}
		} catch (e) {
			console.log(e);
		}
	};

	const relogin = async (reconnect) => {
		const { session } = await weave.reconnect();
		const isAuthorized = session.scopes.includes("codiax");
		setHasAccess(isAuthorized)
		if (isAuthorized) {
			history.push(`/${path}/data`);
		}
	};

	const connectToMetamask = (reconnect) => {
		meta.connect().then(reconnect ? relogin : login);
	}

	return (
		<CodiaxProvider value={{ weave, user, hasAccess, showConnect, showMint, login, logout, connectToMetamask }}>
			<Switch>
				<Route path={`/${path}/mint`} exact component={CodiaxMintPage} />
				<Route path={`/${path}/login`} exact component={CodiaxLogin} />
				<Route path={`/${path}/help`} exact component={CodiaxHelpPage} />
				<Route path={`/${path}/data`} exact component={CodiaxDataPage} />
				<Route component={CodiaxLogin} />
			</Switch>
		</CodiaxProvider>
	);
}
